const Defaults = {
  isDarkTheme: true,
  locale: 'EN'
};
export default Defaults;